
















































import { mapGetters, mapActions } from 'vuex'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { cloneDeep, union, filter, isEmpty, isEqual } from 'lodash'

@Component
export default class FilterLists extends Vue {

  get filterList(): Array<{
    condition: string,
    value: string,
  }> {
    if (this.isChange) {
      this.isChange = false
    }
    return this.filterModel
  }

  get conditionSelect(): string[] | undefined {
    return this.operation || []
  }

  @Prop() private value !: any
  @Prop() private operation !: any
  @Prop() private checkEmpty !: boolean
  private filterModel!: Array<{condition: string, value: string}>
  private isChange = false

  private created() {
    this.filterModel = isEmpty(this.value)
      ? [{condition: '', value: ''}]
      : this.clearEmptyFilter(this.value)
  }

  // @Watch('filterModel', {deep: true})
  private onFiltersChange() {
    this.isChange = true
    const cleanFilter = this.clearEmptyFilter(this.filterModel)
    if (isEmpty(this.value) && isEmpty(cleanFilter)) {
      return
    }
    if (isEqual(this.value, cleanFilter)) {
      return
    }
    // console.log(!(isEqual(this.value, cleanFilter) || (isEmpty(this.value) && isEmpty(cleanFilter))))
    this.$emit('input', cleanFilter)
  }

  private clearEmptyFilter(list: Array<{condition: string, value: string}>) {
    return filter(
      cloneDeep(list),
      (item) => item.condition && (
        ['is empty', 'is not empty'].includes(item.condition) || item.value
      ),
    ) as Array<{condition: string, value: string}>
  }

  private addFilter() {
    this.filterModel.push({condition: '', value: ''})
    this.isChange = true
  }

  private deleteFilter(index: number) {
    if (this.filterModel.length > 1) {
      this.filterModel.splice(index, 1)
    } else {
      this.filterModel[index] = {
        condition: '',
        value: '',
      }
    }
    this.onFiltersChange()
  }
}
